import React from 'react'
import { Banner } from '../ui'

export function DeletionPendingBanner({ deletionRequest }) {
  if (!deletionRequest) return null

  const scheduledDate = new Date(deletionRequest.scheduledFor).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })

  return (
    <Banner tone="error" icon="⚠">
      Your account and all data will be permanently deleted on{' '}
      <strong>{scheduledDate}</strong>.{' '}
      To cancel, go to <strong>Settings</strong>.
    </Banner>
  )
}
